import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementDetailsManager, type IAgreementDetail } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getAccessControlModule } from '../base/access-control/module';
import { actions } from './actions';

const AGREEMENT_DETAIL_MODULE = 'agreementDetail';

const dataObjectModule = getDataObjectsModule<IAgreementDetail>(agreementDetailsManager);
const searchModule = getSearchModule<IAgreementDetail>(agreementDetailsManager);
const accessControlModule = getAccessControlModule<IAgreementDetail>(agreementDetailsManager);

const agreementDetailModuleInstance = merge<unknown>(dataObjectModule, searchModule, accessControlModule, { actions });
store.registerModule(AGREEMENT_DETAIL_MODULE, agreementDetailModuleInstance);

export { AGREEMENT_DETAIL_MODULE };
